import React from "react";
import { useState } from "react";
import { Card, Grid, Typography } from "@mui/material";
import { Divider } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Account } from "./Account";
//import Favorite from './Favorite';
import History from "./History";
import Good from "./Good";
import { UserTable } from "./UserTable";
import { mainListItems, subListItems } from "./ListItems";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import CatalogueTable from "./CatalogueTable";
import { useAuthContext } from "../../Modules/Auth/AuthContext";
import { AdminRoute, EditRoute } from "../../Modules/Auth/PrivateRoute";
import "./MyPagaStyle/Mypage.css";
import MStudyForm from "./MStudyForm";
import MStudyList from "./MStudyList";

export default function Mypage() {
  const { height, width } = useWindowDimensions();
  const { userData } = useAuthContext();
  const { MypageKind, ActionKind, ObjectId } = useParams();
  const navigate = useNavigate();

  const handleLink = (name: string) => {
    if (name === "Account") {
      navigate("/mypage/account");
    } else if (name === "Favorite") {
      navigate("/mypage/favorite");
    } else if (name === "Good") {
      navigate("/mypage/good");
    } else if (name === "History") {
      navigate("/mypage/history");
    } else if (name === "Catalogue") {
      navigate("/mypage/catalogue");
    } else if (name === "User") {
      navigate("/mypage/user");
    } else if (name === "Search") {
      navigate("/manage/catalogue/disease")
    } else if (name === "MStudy") {
      navigate("/mypage/mstudy");
    }

  };

  let body;
  let show;
  switch (MypageKind) {
    case "account":
      show = "true";
      body = <Account />;
      break;
    // case "favorite":
    //   body = <Favorite />;
    //   show = "true";
    //   break;
    case "good":
        show = "true";
        body = <Good />;
        break;
    case "history":
      body = <History />;
      show = "true";
      break;
    case "catalogue":
      body = <EditRoute children={<CatalogueTable />}></EditRoute>;
      show = "true";
      break;
    case "user":
      body = <AdminRoute children={<UserTable />}></AdminRoute>;
      show = "true";
      break;
    case "mstudy":
      if (ActionKind === "new") {
        body = <EditRoute children={<MStudyForm />}></EditRoute>;
      } else if (ObjectId === "edit") {
        // e.g. /mypage/mstudy/:id/edit
        body = <EditRoute children={<MStudyForm />}></EditRoute>;
      } else {
        body = <EditRoute children={<MStudyList />}></EditRoute>;
      }
      show = "true";
      break;
    default:
      show = "false";
      body = (
        <div>
          <h1>404 Not Found</h1>
          <h3>こちらのページは存在しません。</h3>
        </div>
      );
  }

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div>
        {show === "true" ? (
          <div>
            {width > 400 ? (
              <Grid sx={{ mt: 1 }} display="flex">
                <Grid className="MypageBar" sx={{ mt: 1 }} width="20%">
                  <React.Fragment>
                    {mainListItems.map((item) => (
                      <div
                        key={item.name}
                        onClick={() => handleLink(item.name)}
                      >
                        {item.item}
                      </div>
                    ))}
                    <Divider />
                    {subListItems.map((item) => {
                      if (item.auths.includes(userData?.userStatus || "")) {
                        return (
                          <div
                            key={item.name}
                            onClick={() => handleLink(item.name)}
                          >
                            {item.item}
                          </div>
                        );
                      }
                    })}
                    {/*
                                        <Typography mt={1} mb={1} ml={2} variant="body2" color="text.secondary" >
                                            アップロード
                                        </Typography>
                                        {subListItems.map((element) => {
                                            if (userData.userStatus === 'normal') {
                                                if (element.name === 'Upload')
                                                    return (
                                                        <div key={element.name}
                                                            onClick={() => handleLink(element.name)}>
                                                            {element.item}
                                                        </div>
                                                    )
                                            } else {
                                                return (
                                                    <div key={element.name}
                                                        onClick={() => handleLink(element.name)}>
                                                        {element.item}
                                                    </div>
                                                )

                                            }
                                        })
                                    }
                                        */}
                  </React.Fragment>
                </Grid>
                <Grid width="80%">{body}</Grid>
              </Grid>
            ) : (
              <Grid sx={{ mt: 1 }}>
                <Grid
                  className="MypageBarShort"
                  sx={{ mt: 1 }}
                  display="flex"
                  overflow="scroll"
                >
                  {mainListItems.map((item) => (
                    <Grid
                      key={item.name}
                      display="inline-block"
                      onClick={() => handleLink(item.name)}
                    >
                      {item.item}
                    </Grid>
                  ))}
                  {subListItems.map((item) => (
                    <Grid
                      key={item.name}
                      display="inline-block"
                      onClick={() => handleLink(item.name)}
                    >
                      {item.item}
                    </Grid>
                  ))}
                </Grid>
                <Grid>{body}</Grid>
              </Grid>
            )}
          </div>
        ) : (
          <div>{body}</div>
        )}
      </div>
    </div>
  );
}
